import React from 'react'
import { Navigate } from 'react-router-dom';

const ProtectedRoutes = ({ children, requiredRole }) => {
    const role = localStorage.getItem("role");
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    if (requiredRole) {
        if (
            (requiredRole === 'admin' && !(role === 'admin' || role === 'superAdmin'))
            ||
            (Array.isArray(requiredRole) && !requiredRole.includes(role))
            ||
            (typeof requiredRole === 'string' && requiredRole !== 'admin' && requiredRole !== role)
        ) {
            localStorage.clear();
            return <Navigate to="/login" />;
        }
    }

    return children;
}

export default ProtectedRoutes